import { useCallback, useState } from 'react';

import { logout } from '@/shared/lib/logout';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';

export const useLogout = () => {
  const [isLoading, setIsLoading] = useState(false);

  const onLogout = useCallback(async () => {
    try {
      setIsLoading(true);

      await logout();
    } catch (e) {
      showErrorAlert(e);
    }

    setIsLoading(false);
  }, []);

  return { isLoggingOut: isLoading, logout: onLogout };
};
